function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 24,
  height: 24
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.7,21.8H2.5V6.3h8.8V3.8H2.5C1.1,3.8,0,4.9,0,6.3v15.2C0,22.9,1.1,24,2.5,24h15.2c1.4,0,2.5-1.1,2.5-2.5v-8.8h-2.5 V21.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2,0h-2.5v3.8h-3.8c0,0,0,2.5,0,2.5h3.8v3.8c0,0,2.5,0,2.5,0V6.3H24V3.8h-3.8V0z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 5.1,
  y: 8.8,
  width: 10.1,
  height: 2.5
}), /*#__PURE__*/React.createElement("polygon", {
  points: "5.1,12.6 5.1,15.2 15.2,15.2 15.2,12.6 11.4,12.6  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 5.1,
  y: 16.4,
  width: 10.1,
  height: 2.5
})));

function SvgPostAdd24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostAdd24Px);
export default __webpack_public_path__ + "static/media/post_add-24px.f19ed553.svg";
export { ForwardRef as ReactComponent };